var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"pandaPlayer",staticStyle:{"position":"relative","border":"10px","width":"100%","max-width":"980px","aspect-ratio":"16/9"},attrs:{"allow":"fullscreen","id":"panda-player","src":_vm.source}})
}
var staticRenderFns = []

export { render, staticRenderFns }